/**
 * iframe通信子页面
 * versoin:1.0.0
 * likan
 * 2020-6-29
*/
let MyBridge = function(callBack) {
  let that = this;
  window.addEventListener("message", function(event) {
    if (event.data.code === "monitor23Once") {
      that.parentUrl = event.data.data.parentUrl;
    } else if ((event.data.code === "monitor23")) {
      callBack(event.data.data);
      that.getInvoke(event.data.data);
    }
  });
};

MyBridge.prototype = {
  getInvoke(data) {
    // todo

  },
  invoke(cmd, code) {
    window.parent.postMessage({ layerData: cmd, code: code }, this.parentUrl);
  },
  destory() {
    window.removeEventListener("message");
  }
};

export default MyBridge;
